import { arbor } from './leads/arbor'
import { Lead } from './leads/Lead.js'

export const leads: Lead[] = [arbor]
